import React from 'react';
import {Box, Flex, Text, VStack} from '@chakra-ui/react';
import {IntegrationDetailsHeader} from './IntegrationDetailsHeader';
import {useIntegrationFromContext} from './IntegrationDetailsContext';
import {IntegrationSection} from './components';
import {DeleteIntegrationButton} from './DeleteIntegrationButton';

export const SlackIntegrationDetails = () => {
  const integration = useIntegrationFromContext('slack');

  return (
    <Flex direction="column" gap="8">
      <IntegrationDetailsHeader>
        <DeleteIntegrationButton warningMessage="This will disable Slack notifications and remove any connected channels." />
      </IntegrationDetailsHeader>

      <IntegrationSection>
        <VStack align="start" spacing="4">
          <Box fontSize="lg" fontWeight="500">
            Connected Channel
          </Box>

          {integration.webhookChannel ? (
            <Text>
              This integration is connected to{' '}
              <strong>{integration.webhookChannel}</strong>.
            </Text>
          ) : (
            <Text>
              This integration is not yet connected to a Slack channel.
            </Text>
          )}

          <Text fontSize="sm" color="kgray.300">
            To change the connected channel, you&apos;ll need to re-authenticate
            the integration.
          </Text>
        </VStack>
      </IntegrationSection>
    </Flex>
  );
};
